import { useNavigate } from 'react-router-dom';

import { cn } from '~/utils/cn';

import Avatar from '../../atoms/Avatar/view';
import { Icon } from '../../atoms/Icon/view';
import { Text } from '../../atoms/Text/view';

interface PropsHeaderHome {
  userName: string;
  farmName?: string;
  greeting: string;
  unreadCount?: number;
  onClickAvatar?: () => void;
  className?: string;
}

const GRADIENT_BG = {
  background: 'linear-gradient(135deg, #1D4733 0%, #3F7D5F 100%)',
};

export default function HeaderHome({
  userName,
  farmName,
  greeting,
  unreadCount = 0,
  onClickAvatar,
  className,
}: PropsHeaderHome) {
  const navigate = useNavigate();
  return (
    <div
      className={cn('w-full overflow-hidden rounded-b-[24px] pb-middle', className)}
      style={GRADIENT_BG}
    >
      <div className="w-full p-small pt-large pb-xxxl">
        <div className="flex items-center justify-between gap-smaller">
          <button
            type="button"
            onClick={onClickAvatar}
            className="flex items-center gap-smaller text-left min-w-0 flex-1 hover:opacity-90"
          >
            <Avatar
              name={userName}
              seed={userName}
              size="md"
              className="border border-intense-01/20"
            />
            <div className="min-w-0">
              <Text className="text-captionLG color-intense-04">
                {greeting ?? 'Olá,'}
              </Text>
              <Text
                className="text-paragraphLG color-intense-01"
                numberOfLines={1}
              >
                {userName}
              </Text>
              {farmName ? (
                <Text
                  className="text-captionMD color-intense-04"
                  numberOfLines={1}
                >
                  {farmName}
                </Text>
              ) : null}
            </div>
          </button>

          <button
            type="button"
            onClick={() => navigate('/app/notifications')}
            className="relative h-[44px] w-[44px] rounded-[14px] bg-intense-01/15 flex items-center justify-center shrink-0 hover:bg-intense-01/25"
          >
            <Icon name="icon-notification" size={20} color="#FFFFFF" rounded={false} />
            {unreadCount > 0 ? (
              <span className="absolute right-[6px] top-[6px] min-w-[16px] h-[16px] rounded-full bg-warning-03 px-quark flex items-center justify-center">
                <Text inline className="text-captionMD color-intense-01">
                  {unreadCount > 9 ? '9+' : String(unreadCount)}
                </Text>
              </span>
            ) : null}
          </button>
        </div>
      </div>
    </div>
  );
}
